<template>
    <section>
        <div class="flex md:flex-col">
            <AdminDashboardNav/>

            <div class="w-screen">
                <div class="flex justify-between pl-10 pr-10 md:p-2 pt-5 md:flex-col-reverse">
                    <div class="md:mt-3">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-lg">TRANSACTIONS</p>
                    </div>
                    <div>
                        <Notification/>
                    </div>
                </div>

                <TransactionList/>

            </div>

        </div>
    </section>
</template>

<script>
import AdminDashboardNav from '../../AdminDashboardNav.vue';
import GetDate from '../../GetDate.vue';
import Notification from '../../Notification.vue';
import TransactionList from './TransactionList.vue';
export default {
    components : {
        AdminDashboardNav,
        GetDate,
        Notification,
        TransactionList
    }
}
</script>